/**
 * @generated SignedSource<<b9a1a4f1396d64e731bee0f6e9b013a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreTemplate = "GROCERY_STORE" | "GROCERY_STORE_LARGE" | "GROCERY_STORE_SMALL";
export type CreateStoreComponentMutation$variables = {
  name: string;
  template?: StoreTemplate | null;
};
export type CreateStoreComponentMutation$data = {
  readonly createStore: {
    readonly id: string;
    readonly name: string;
    readonly timezone: string;
  } | null;
};
export type CreateStoreComponentMutation = {
  response: CreateStoreComponentMutation$data;
  variables: CreateStoreComponentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "template"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "storeName",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "template",
        "variableName": "template"
      }
    ],
    "concreteType": "Store",
    "kind": "LinkedField",
    "name": "createStore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timezone",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateStoreComponentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateStoreComponentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6cbd67193976b7e9ced4c744083c4a15",
    "id": null,
    "metadata": {},
    "name": "CreateStoreComponentMutation",
    "operationKind": "mutation",
    "text": "mutation CreateStoreComponentMutation(\n  $name: String!\n  $template: StoreTemplate\n) {\n  createStore(storeName: $name, template: $template) {\n    id\n    name\n    timezone\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1ee9de97e24b39efd1ba97312ddcf9b";

export default node;
